import { Link, useNavigate } from "react-router-dom";
import "./AreaCreation.css";
import BackButton from "../../../../../sharedComponents/backButton/BackButton";
import { TextField } from "@mui/material";
import { useState } from "react";
import PrimaryButton from "../../../../../sharedComponents/primaryButton/PrimaryButton";
import axios from "axios";

function AreaCreation(){

    const [nameError, setNameError] = useState(false);
    const [name, setName] = useState('');
    const navigate = useNavigate();
    
    const saveNewArea = () => {
        axios.post('area', {
            "name": name
        }).then(() => {
            navigate("/home/settings/bereiche");
            /* window.location.assign("/home/settings/bereiche") */
        }).catch((error) => {
            console.log(error);
            
        })
    }

    const handleTextChange = (e) => {
        setName(e.target.value);
        if(e.target.value === "") setNameError(true);
    }

    return(
        <>
            <div className="area-creation-container">
                <Link to={"/home/settings/bereiche"}><BackButton /></Link>
                <h4>Neuen Bereich anlegen</h4>
                <div className="area-creation-body">
                    <TextField
                        required 
                        error={nameError} 
                        label="Bezeichnung" 
                        variant="outlined" 
                        helperText={nameError ? "Feld darf nicht leer sein" : false} 
                        onChange={e => handleTextChange(e)}
                    />
                    <PrimaryButton text="Neuen Bereich erstellen" onClick={saveNewArea} disabled={name === ""} /> 
                </div>                
            </div>
        </>
    )
}

export default AreaCreation;